/** Parse a YouTube watch / shorts / youtu.be / embed URL into an embeddable video id. */
export function youtubeVideoId(url) {
  const raw = String(url || "").trim();
  if (!raw) return null;
  const m = raw.match(
    /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );
  if (m) return m[1];
  const v = raw.match(/[?&]v=([A-Za-z0-9_-]{11})/);
  return v ? v[1] : null;
}

export function youtubeEmbedUrl(url, { autoplay = false } = {}) {
  const id = youtubeVideoId(url);
  if (!id) return null;
  const extra = autoplay ? "&autoplay=1" : "";
  return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&playsinline=1${extra}`;
}

export function youtubePosterUrl(url) {
  const id = youtubeVideoId(url);
  if (!id) return null;
  return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
}
